export const createGoogleMapLink = (lat: string, long: string): string | null => {
  const baseUrl = 'https://www.google.com/maps/search/?api=1';

  return long && lat ? `${baseUrl}&query=${lat}%2C${long}` : null;
};
